import { tween } from './transitions'

export const curtainVariants = {
  initial: {
    y: '100vh',
    transition: tween('normal', true)
  },
  visible: {
    y: 0,
    transition: tween('normal', true)
  },
  hidden: {
    y: '-100vh',
    transition: { ...tween('normal', true), delay: 0.3 }
  }
}

export const listItemVariants = {
  initial: {
    opacity: 0,
    x: 160
  },
  visible: i => ({
    opacity: 1,
    x: 0,
    transition: {
      ...tween('normal', true),
      delay: i * 0.1 + 0.3
    }
  }),
  hidden: {
    opacity: 0,
    transition: tween('normal', true)
  }
}

export const fadeScaleVariants = {
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      ...tween('normal'),
      duration: 0.3
    }
  },
  hidden: {
    opacity: 0,
    scale: 1.05,
    transition: {
      ...tween('normal'),
      duration: 0.2
    }
  }
}

export const zoomInVariants = {
  visible: {
    opacity: 1,
    scale: 1,
    transition: tween('normal', true)
  },
  hidden: {
    opacity: 0,
    scale: 0.8,
    transition: tween('normal', true)
  }
}

export const pointRightVariants = {
  initial: {
    x: 0
  },
  hover: {
    x: [0, -12, 0],
    transition: {
      ...tween('normal', true, true),
      duration: 1.2,
      repeat: Infinity
    }
  }
}

export const pointLeftVariants = {
  initial: {
    x: 0
  },
  hover: {
    x: [0, 12, 0],
    transition: {
      ...tween('normal', true, true),
      duration: 1.2,
      repeat: Infinity
    }
  }
}
